export default __webpack_public_path__ + "static/media/community-greenie-digitas.13537185.png";